export default __webpack_public_path__ + "static/media/vectorHeart.eafaa85d.svg";